import * as React from "react";
import { useRender } from "@base-ui/react/use-render";

// Base UI-backed drop-in for Radix's `Slot`: merges the given props (className,
// events, ref, data-*) onto a single child element while preserving the child's
// element type and semantics. Base UI's own `useRender` is the Slot equivalent;
// this wraps it so shadcn components that expose `asChild`
// (`const Comp = asChild ? Slot : "div"`) or render `<Slot>` directly (FormControl)
// keep their existing shape with only an import swap. See button.tsx for the
// same useRender approach applied inline.
type SlotProps = React.HTMLAttributes<HTMLElement> & {
	children?: React.ReactNode;
	ref?: React.Ref<HTMLElement>;
};

function Slot({ children, ...props }: SlotProps) {
	return useRender({
		render: children as React.ReactElement,
		props: props as Record<string, unknown>,
	});
}

export { Slot };
